module.exports = __webpack_public_path__ + "static/media/cat.55202897.png";